// src/components/maintenance.jsx
import React from 'react';

const GOLD = '#B8860B';
const DARK_NAVY = '#050a0f';

export default function Maintenance() {
  return (
    <div style={container}>
      {/* Background Decorative Element */}
      <div style={bgGlow}></div>

      <div style={contentCard}>
        <div style={logoWrapper}>
          <img 
            src="/icons/esdras-logo.png" 
            style={logoStyle} 
            alt="Esdras Logo" 
            onError={(e) => e.target.style.display = 'none'} // Hides broken img icon if path is wrong
          />
        </div>
        
        <h1 style={titleStyle}>SYSTEM UPGRADE</h1>
        
        <div style={divider}></div>
        
        <p style={messageStyle}>
          We are currently performing scheduled maintenance to enhance your experience. 
          Our team is working to bring new features and improvements to the platform.
        </p>

        <div style={statusContainer}>
          <div style={pulseDot}></div>
          <span style={statusText}>SERVER OPTIMIZATION IN PROGRESS</span>
        </div>

        <p style={footerStyle}>
          Estimated completion: <span style={{ color: GOLD, fontWeight: 'bold' }}>Under 30 minutes</span>
        </p>
      </div>

      <style>{`
        @keyframes pulse {
          0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(184, 134, 11, 0.7); }
          70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(184, 134, 11, 0); }
          100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(184, 134, 11, 0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

// STYLES
const container = {
  height: '100vh',
  width: '100vw',
  background: DARK_NAVY,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  overflow: 'hidden',
  position: 'relative',
  fontFamily: 'sans-serif'
};

const bgGlow = {
  position: 'absolute',
  width: '600px', // Increased slightly for better depth
  height: '600px',
  background: `radial-gradient(circle, rgba(184, 134, 11, 0.08) 0%, rgba(5, 10, 15, 0) 70%)`,
  zIndex: 1
};

const contentCard = {
  zIndex: 2,
  textAlign: 'center',
  padding: '40px',
  maxWidth: '500px',
  animation: 'fadeIn 0.8s ease-out'
};

const logoWrapper = {
  marginBottom: '30px',
  minHeight: '60px' 
};

const logoStyle = {
  width: '100px',
  height: 'auto',
  filter: 'drop-shadow(0 0 15px rgba(184, 134, 11, 0.3))'
};

const titleStyle = {
  fontSize: '1.6rem',
  letterSpacing: '8px',
  color: GOLD,
  fontWeight: '300',
  margin: '0 0 20px 0',
  textTransform: 'uppercase'
};

const divider = {
  width: '40px',
  height: '1px',
  background: GOLD,
  margin: '0 auto 30px auto',
  opacity: 0.6
};

const messageStyle = {
  fontSize: '0.95rem',
  lineHeight: '1.8',
  opacity: 0.8,
  marginBottom: '40px',
  fontWeight: '300',
  letterSpacing: '0.5px'
};

const statusContainer = {
  display: 'inline-flex', // Prevents full-width stretch
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  background: 'rgba(255,255,255,0.03)',
  padding: '12px 24px',
  borderRadius: '50px',
  border: '1px solid rgba(255,255,255,0.08)',
  marginBottom: '25px'
};

const pulseDot = {
  width: '8px',
  height: '8px',
  background: GOLD,
  borderRadius: '50%',
  animation: 'pulse 2s infinite'
};

const statusText = {
  fontSize: '0.65rem',
  letterSpacing: '2px',
  fontWeight: '600',
  opacity: 0.9
};

const footerStyle = {
  fontSize: '0.75rem',
  opacity: 0.5,
  letterSpacing: '1px'
};
